export default __webpack_public_path__ + "1f6a257991a42936ea9a8e8311cfc77b.ttf";